<div class="bg-primary h-full">
  @if (technician) {
    <form [formGroup]="formGroup" class="h-full d-flex flex_col" (submit)="onSubmit()">
      <h6 class="p-3">Bundesland für {{ technician.firstname }} {{ technician.lastname }} auswählen</h6>
      <div class="bg-base-100 p-2 d-flex flex-column">
        <mat-form-field appearance="outline" class="no-subscript outline-small">
          <mat-label>Bundesland auswählen</mat-label>
          <mat-select formControlName="state">
            <mat-option value="de-bb"> Brandenburg </mat-option>
            <mat-option value="de-be"> Berlin </mat-option>
            <mat-option value="de-bw"> Baden-Württemberg </mat-option>
            <mat-option value="de-by"> Bayern </mat-option>
            <mat-option value="de-hb"> Bremen </mat-option>
            <mat-option value="de-he"> Hessen </mat-option>
            <mat-option value="de-hh"> Hamburg </mat-option>
            <mat-option value="de-mv"> Mecklenburg-Vorpommern </mat-option>
            <mat-option value="de-ni"> Niedersachsen </mat-option>
            <mat-option value="de-nw"> Nordrhein-Westfalen </mat-option>
            <mat-option value="de-rp"> Rheinland-Pfalz </mat-option>
            <mat-option value="de-sh"> Schleswig-Holstein </mat-option>
            <mat-option value="de-sl"> Saarland </mat-option>
            <mat-option value="de-sn"> Sachsen </mat-option>
            <mat-option value="de-st"> Sachsen-Anhalt </mat-option>
            <mat-option value="de-th"> Thüringen </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="text-muted p-2 w-75" style="font-size: 12px">
          Bitte beachten Sie, dass die Änderungen erst nach Neustart der Seite aktiv werden!
        </div>
        <div class="flex_row m-1">
          <button type="button" class="mr8 ml-auto bm-btn" (click)="closeComponent.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" [disabled]="!formGroup.valid">Bundesland speichern</button>
        </div>
      </div>
    </form>
  }
</div>
